import { useLocation, useNavigate, useParams } from 'react-router-dom';

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Drawer from '@mui/material/Drawer';

import DashboardIcon from "@mui/icons-material/Dashboard";
import AppSettingsAltIcon from "@mui/icons-material/AppSettingsAlt";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import SettingsIcon from '@mui/icons-material/Settings';
import ReportIcon from "@mui/icons-material/Report";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import { DrawerHeader} from "../common/utils";

const NavListItem = ({ label, Icon, Url, drawerOpen, closeDrawer, theme}) => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleNav = (page) => () => {
        window.scrollTo(0, 0);
        closeDrawer();
        navigate(page);
    };
    
    return(
        <ListItem disablePadding sx={{ display: "block" }}>
            <ListItemButton
                sx={{
                    minHeight: 48,
                    justifyContent: drawerOpen ? "initial" : "center",
                    px: 2.5,
                    bgcolor: location.pathname === Url ? 'black': 'white',
                    color: location.pathname === Url ? 'white': 'black'
                }}
                onClick={handleNav(Url)}
            >
            <ListItemIcon
                sx={{
                minWidth: 20,
                mr: drawerOpen ? 3 : "auto",
                justifyContent: "center",
                color: location.pathname === Url ? 'white': 'black'
                }}
            >
                <Icon />
            </ListItemIcon>
            <ListItemText primary={label} sx={{ opacity: drawerOpen ? 1 : 0 }} />
            </ListItemButton>
        </ListItem>
    );
};

const MobileNav = ({ drawerOpen, closeDrawer, theme, headerData }) => {
  const { company } = useParams();
  const navItems = [
    { key: "dashboard", label: "Dashboard", Url:`/Portal/${company}/Dashboard`, Icon: DashboardIcon },
    { key: "product-manage", label: "Manage Product", Url:`/Portal/${company}/Product`, Icon: AppSettingsAltIcon },
    { key: "reports", label: "Reports", Url:`/Portal/${company}/Reports`, Icon: ReportIcon },
    { key: "users", label: "Users", Url:`/Portal${company}//Users`, Icon: AccountCircleIcon },
    { key: "settings", label: "Settings", Url:`/Portal/${company}/Settings`, Icon: SettingsIcon },
  ];
  if (!drawerOpen) return null;

  const capabilities = headerData?.capabilities || {};

  const filteredNavItems = navItems.filter(({ key }) => capabilities[key] !== false);

  return (
    <Drawer open={drawerOpen} onClose={closeDrawer}>
      <DrawerHeader>
        <IconButton onClick={closeDrawer}>
          {theme.direction === "rtl" ? <ChevronRightIcon /> : <ChevronLeftIcon />}
        </IconButton>
      </DrawerHeader>
      <Divider />
      <List>
        {filteredNavItems.map(({ key, label, Icon, Url }) => (
          <div key={key}>
            <NavListItem
              label={label}
              Icon={Icon}
              Url={Url}
              drawerOpen={drawerOpen}
              closeDrawer={closeDrawer}
              theme={theme}
            />
            <Divider />
          </div>
        ))}
      </List>
    </Drawer>
  );
};
  

export default MobileNav;
